import * as React from "react";
import { Route } from 'react-router-dom';
import { ProfileEdit } from "reactAdmin/resource/user/profileEdit";
import UserSignUp from "reactAdmin/resource/user/userSignUp";
import UserVerify from "reactAdmin/resource/user/userVerify";
import AcceptInvitation from "reactAdmin/resource/user/acceptInvitation";
import UserRegistered from "reactAdmin/resource/user/userRegistered";
import ForgotPassword from "reactAdmin/resource/user/forgotPassword";
import ResetPassword from "reactAdmin/resource/user/resetPassword";
import ChangePassword from "reactAdmin/resource/user/changePassword";

const customRoutes = [
    // @ts-ignore
    <Route exact path="/signup" component={UserSignUp} noLayout />,
    // @ts-ignore
    <Route exact path="/registered" component={UserRegistered} noLayout />,
    // @ts-ignore
    <Route exact path="/verify" component={UserVerify} noLayout />,
    // @ts-ignore
    <Route exact path="/forgot" component={ForgotPassword} noLayout />,
    // @ts-ignore
    <Route exact path="/reset-password" component={ResetPassword} noLayout />,
    // @ts-ignore
    <Route exact path="/accept-invitation" component={AcceptInvitation} noLayout />,
    <Route path="/profile" component={ProfileEdit} />,
    <Route path="/change-password" component={ChangePassword} />,
];

export default customRoutes;